import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import PublicRouter from "./PublicRouter";
import PrivateRouter from "./PrivateRouter";

import Login from "../Components/Login";
import Signup from "../Components/Signup";
import Dashboard from "../Components/Dashboard";
import TempCustomer from "../Components/TempCustomer";

import { useAuth } from "../Contexts/AuthenticateProvider";

const Index = () => {
  const { profileDetails } = useAuth();
  return (
    <Router>
      <Routes>
        <Route element={<PublicRouter />}>
          <Route index element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>

        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={ profileDetails?.accountType === "customer" ? <Dashboard /> : <TempCustomer /> }/>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default Index;